var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 7 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M0 0h3M0 1h1m2 0h1M0 2h1m2 0h1M0 3h1m3 0h1M0 4h1m3 0h1M0 5h1m4 0h1M0 6h1m4 0h1M0 7h1m3 0h1M0 8h1m3 0h1M0 9h1m2 0h1m-4 1h1m2 0h1m-4 1h3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5a5849",
    d: "M3 0h1m0 1h1M4 2h1m0 1h1M5 4h1m0 1h1M6 6h1M5 7h1M5 8h1M4 9h1m-1 1h1m-2 1h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5c9e25",
    d: "M1 1h1M1 2h1M1 3h1M1 4h1M1 5h1M1 6h1M1 7h1M1 8h1M1 9h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#005622",
    d: "M2 1h1M2 2h1m0 1h1M3 4h1m0 1h1M4 6h1M3 7h1M3 8h1M2 9h1m-1 1h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#208720",
    d: "M2 3h1M2 4h1M2 5h2M2 6h2M2 7h1M2 8h1m-2 2h1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurn);
export default __webpack_public_path__ + "static/media/turn.fe06e93e3f5ca9ad63c89d7e8f85aa48.svg";
export { ForwardRef as ReactComponent };